module["exports"] = [
  "+49-1##-#######",
  "+49-1###-########"
];
